// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"93fc10c4","459":"b00ce244","778":"62419362","815":"e75b87f4","862":"2a1dffcc"}[chunkId] + ".chunk.css";
};